import { render } from "./App.vue?vue&type=template&id=4d6cf989"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4d6cf989&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__